import { useState } from "react";
import { ReactComponent as MarkIcon } from "../../Asset/fluent_checkmark-circle-24-regular.svg";
import "./job.css";

const categoryData = {
  "Deck Department": [
    "Captain (Master)",
    "Chief Officer (Chief Mate)",
    "Second Officer (Second Mate)",
    "Third Officer (Third Mate)",
    "Able Seaman (AB)",
    "Ordinary Seaman (OS)",
    "Bosun (Boatswain)",
    "Deck Cadet",
  ],
  "Engine Department": [
    "Chief Engineer",
    "Second Engineer",
    "Third Engineer",
    "Fourth Engineer",
    "Engine Cadet",
    "Motorman",
    "Oiler",
    "Wiper",
  ],
  "Electrical & Technical Department": [
    "Electro-Technical Officer (ETO)",
    "Electrical Engineer",
    "Technical Superintendent",
    "Marine Technician",
  ],
  "Catering & Hospitality": ["Chief Cook", "Steward", "Messman"],
  "Shore-Based & Port Operations": [
    "Port Captain",
    "Port Engineer",
    "Harbor Master",
    "Terminal Manager",
    "Vessel Traffic Controller",
    "Marine Surveyor",
    "Ship Agent",
    "Cargo Planner",
  ],
  "Offshore & Oil and Gas": [
    "Offshore Installation Manager (OIM)",
    "Dynamic Positioning Operator (DPO)",
    "Crane Operator",
    "Roustabout",
    "Rigger",
    "Diver",
    "Subsea Engineer",
  ],
  "Maritime Logistics & Supply Chain": [
    "Freight Forwarder",
    "Ship Broker",
    "Marine Logistics Coordinator",
    "Customs Officer",
  ],
  "Naval Architecture & Marine Engineering": [
    "Naval Architect",
    "Marine Engineer",
    "Shipbuilding Engineer",
    "Marine Surveyor",
  ],
  "Maritime Security & Safety": [
    "Maritime Security Officer",
    "Safety Officer",
    "Environmental Compliance Officer",
    "Search and Rescue (SAR) Specialist",
  ],
};

const Jobs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    category: "",
    position: "",
    term: "",
    countryCode: "+234",
    phone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "category") {
      setFormData({
        ...formData,
        category: value,
        position: "",
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  return (
    <div className="job-container">
      <div className="wrap">
        <div className="inner">
          <div className="box">
            <h3>Empowering Your Career Journey</h3>
            <p>
              At Vatug, we believe everyone deserves a job they love. Our
              mission is to connect job seekers with their dream opportunity by
              providing a comprehensive platform to bridge the gap between
              talent & employers.
            </p>
          </div>

          <div className="form-container">
            <h3>Join our Waitlist</h3>
            <p>Find the job that best suits you</p>

            <div className="input-group">
              <input
                type="text"
                name="firstName"
                placeholder="First name"
                value={formData.firstName}
                onChange={handleChange}
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last name"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>

            <input
              type="email"
              name="email"
              placeholder="example@email.com"
              value={formData.email}
              onChange={handleChange}
            />

            {/* Category Dropdown */}
            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
            >
              <option value="">Select Category</option>
              {Object.keys(categoryData).map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>

            {/* Position Dropdown (Dynamic) */}
            <select
              name="position"
              value={formData.position}
              onChange={handleChange}
              disabled={!formData.category}
            >
              <option value="">Select Position</option>
              {formData.category &&
                categoryData[formData.category].map((pos) => (
                  <option key={pos} value={pos}>
                    {pos}
                  </option>
                ))}
            </select>

            <select name="term" value={formData.term} onChange={handleChange}>
              <option value="">Select Term</option>
              <option value="full-time">Full-Time</option>
              <option value="part-time">Part-Time</option>
            </select>

            <div className="phone-group">
              <select
                name="countryCode"
                value={formData.countryCode}
                onChange={handleChange}
                className="country-code"
              >
                <option value="+234">🇳🇬 +234</option>
              </select>
              <input
                type="text"
                name="phone"
                placeholder="Enter phone number"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <button className="submit-btn">JOIN WAITLIST</button>

            <span className="trusted">
              <MarkIcon /> Trusted by 500+ Contractors
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Jobs;
